import { render } from "./StatisticsBlock.vue?vue&type=template&id=2a6c7044&scoped=true"
import script from "./StatisticsBlock.vue?vue&type=script&lang=js"
export * from "./StatisticsBlock.vue?vue&type=script&lang=js"

import "./StatisticsBlock.vue?vue&type=style&index=0&id=2a6c7044&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6c7044"]])

export default __exports__